export default "__VITE_ASSET__Bkr8_sBu__"